import React from 'react';
import { SigSyncAppointmentEditForm } from './EditSignatureSyncAppointment/SigSyncAppointmentEditForm';
import { AppointmentEditForm } from './AppointmentEditForm';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { EditDSSAppointmentForm } from './EditDssAppointment/EditDSSAppointmentForm';

// We have many types of Signing Appointments. Their Edit behaviors are different.
// This is the "top" of the tree, and it determines which form to render.
export const EditAppointment: React.FC<{
  onCloseEditForm: () => void;
}> = ({ onCloseEditForm }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  const isSignatureSyncAppointment = appointmentFromPath?.isSignatureSyncAppointment;
  const isDssMagicLinkSent = appointmentFromPath?.isDigitalScheduling && !appointmentFromPath?.isDigitalSchedulingDraft;

  if (isSignatureSyncAppointment) {
    return <SigSyncAppointmentEditForm onClose={onCloseEditForm} />;
  }
  if (isDssMagicLinkSent) {
    return <EditDSSAppointmentForm onClose={onCloseEditForm} />;
  }

  return <AppointmentEditForm onClose={onCloseEditForm} />;
};
